<template>
  <div class="page-container">
    <headerSection></headerSection>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="floating-ball ball-1"></div>
      <div class="floating-ball ball-2"></div>
      <div class="floating-ball ball-3"></div>

      <div class="container">
        <div class="hero-content">
          <div class="hero-icon-wrapper">
            <span class="hero-icon">🤝</span>
          </div>
          <h1 class="title-glow">{{ $t('link_partner') }}</h1>
          <p class="hero-description">แนะนำเพื่อนรับรางวัล</p>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container main-content">
      <!-- Banner -->
      <div class="banner-section">
        <img src="https://firebasestorage.googleapis.com/v0/b/vr1game.firebasestorage.app/o/images%2F-N5Zi0KwC5SYe4y7Pzwk.png?alt=media&token=5be8ef07-265f-410f-8279-a1562535710a" class="banner-image" alt="Partner Banner">
      </div>

      <!-- Referral Link Card -->
      <div class="referral-card">
        <h5 class="referral-title">{{ $t('partner_title6') }}</h5>
        <div class="referral-input">
          <input id="copyTarget3" type="text" readonly :value="partnerReferralUrl">
          <button class="copy-btn" v-clipboard:copy="partnerReferralUrl"
                  v-clipboard:success="clipboardSuccessHandler">
            <i class="fa fa-copy fa-sm mr-1"></i>{{ $t('copy') }}
          </button>
        </div>
        <p class="referral-note">{{ $t('deposit_title3') }}</p>
      </div>

      <!-- Stats Title -->
      <div class="stats-title">{{ $t('partner_title') }}</div>

      <!-- Partner Stats Grid -->
      <div class="partner-stats">
        <div class="stat-card" @click="showlevel(1)">
          <div class="stat-icon">👥</div>
          <div class="stat-label">{{ $t('partner_title2') }}</div>
          <div class="stat-value">{{ (friends)?friends.length : 0 }}</div>
          <div class="stat-action">
            <img src="../assets/images/analysis.png" width="24" class="analysis-icon">
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">💰</div>
          <div class="stat-label">{{ $t('partner_title4') }}</div>
          <div class="stat-value">{{ (partner && partner.total1)?numberWithCommas(partner.total1):0 }}</div>
        </div>

        <div class="stat-card stat-card-wide">
          <div class="stat-icon">💎</div>
          <div class="stat-label">{{ $t('partner_title6') }}</div>
          <div class="stat-value">{{ (partner && partner.total)?numberWithCommas(partner.total):0 }}</div>
        </div>
      </div>

      <!-- Claim Button -->
      <div class="claim-section">
        <button @click="movePartnerToWallet()"
                :class="['claim-btn', { 'disabled': !(partner && partner.total > 0) }]"
                :disabled="!(partner && partner.total > 0) || disabled">
          {{ $t('partner_title7') }}
        </button>
      </div>

      <!-- Details Section -->
      <div class="details-card" v-if="detail">
        <div class="details-text" v-html="nl2br(detail)"></div>
      </div>
    </div>

    <!-- Modal for detailed history -->
    <div class="modal-overlay" :style="`display: ${(showdetail)?'flex':'none'};`">
      <div class="modal-container">
        <div class="modal-content">
          <button type="button" class="modal-close" @click="closeDetail()">
            <i class="fas fa-times"></i>
          </button>

          <div class="modal-header">
            <h2 class="modal-title">{{titleDetail}}</h2>
          </div>

          <div class="modal-body">
            <p class="modal-subtitle">{{ $t('data_summary_yesterday') }}</p>
            <div class="table-wrapper">
              <div class="fixTableHead">
                <table class="tablecontainer">
                  <thead>
                    <tr>
                      <th><h1>{{ $t('table_code') }}</h1></th>
                      <th><h1>{{ $t('table_date') }}</h1></th>
                      <th><h1>{{ $t('table_deposit') }}</h1></th>
                      <th><h1>{{ $t('table_withdraw') }}</h1></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in history" :key="index">
                      <td>{{item.friend}}</td>
                      <td>{{item.createdateShow}}</td>
                      <td>{{ numberWithCommas(item.deposit) }}</td>
                      <td>{{ numberWithCommas(item.withdraw) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="contact-section">
              <span class="contact-text">
                <label>{{ $t('contact_problem') }}&nbsp;</label>&nbsp;
                <a :href="adminContactLineLink" target="_blank" rel="noopener">
                  <u>{{ $t('contact_customer_service') }}</u>
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
const axios = require('axios').default

const normalizeDomain = (value) => {
  const rawValue = (value || '').toString().trim().toLowerCase()
  if (!rawValue) return ''

  return rawValue
    .replace(/^https?:\/\//, '')
    .replace(/^\/\//, '')
    .split('/')[0]
    .split('?')[0]
    .split('#')[0]
    .replace(/:\d+$/, '')
}

export default {
  name: 'Partner',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  created () {
	  const user = localStorage.getItem('userData')
	  if (user) {
		  const _user = JSON.parse(user)
		  this.$store.dispatch('user/setUser', _user).catch(err => { console.error(err) })
	  } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
	  }
  },
  data: function () {
    return {
      friends:[],
      partner: [],
      showdetail: false,
      titleDetail: '',
      history:[],
      detail:'',
      disabled: false
    }
  },
  mounted () {
    this.scrollToTop()
    this.getPartner()
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    adminContactLineLink () {
      return this.$store.getters['settings/adminContactLineLink'] || this.$store.getters['settings/linkLine']
    },
    partnerReferralHost () {
      const configuredHost = normalizeDomain(this.$store.getters['settings/partnerReferralHost'])
      if (configuredHost) return configuredHost

      const activeDomains = this.$store.getters['settings/activeDomains'] || []
      const firstActiveHost = activeDomains.length ? normalizeDomain(activeDomains[0].host) : ''
      return firstActiveHost || normalizeDomain(window.location.hostname) || 'vr1game-v2.club'
    },
    partnerReferralUrl () {
      const code = this.user && this.user.code ? this.user.code : ''
      return `https://${this.partnerReferralHost}/register?ref=${code}`
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    movePartnerToWallet () {
      if (this.partner.total && this.partner.key && !this.disabled) {
        this.disabled = true;
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally((res) => {
          setTimeout(async () => {
            axios.get(`https://api.vr1game-v2.online/qpartner/partner/${this.partner.key}`)
            setTimeout(() => {
              this.getPartner()
              this.$store.commit('user/SET_LOADING', false)
            }, 2000)
          }, 2000)
        })
        setTimeout(() => {
          this.disabled = false;
        }, 2000);
      }
    },
    clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: this.$t('copy_success') })
    },
    checkStyle () {
      if (this.partner && this.partner.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async getPartner () {
      this.detail = (await firebase.database().ref(`/partner/detail`).once('value')).val();
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.partner = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.partner = data
          })
        })
        firebase.firestore().collection('friends').where('userkey','==',user.key).get().then((result)=>{
          result.forEach((doc)=>{
            const data = doc.data()
            data.key = doc.id
            this.friends.push(data)
          });
        });
      }
    },
    nl2br (str, is_xhtml) {
		if (typeof str === 'undefined' || str === null) {
			return '';
		}
		var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	},
    async showlevel(level){
      const history = [];
      const deposit = [];
      const withdraw = [];
      if(level === 1){
        this.titleDetail = 'แนะนำเพื่อน';
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            deposit[doc.data().code] = doc.data().total;
          });
        });
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            withdraw[doc.data().code] = doc.data().total;
          });
        });
        if(this.friends){
          for(const x in this.friends){
            if(deposit[this.friends[x].friend]){
              this.friends[x].deposit = deposit[this.friends[x].friend];
            }else{
              this.friends[x].deposit = 0;
            }
            if(withdraw[this.friends[x].friend]){
              this.friends[x].withdraw = withdraw[this.friends[x].friend];
            }else{
              this.friends[x].withdraw = 0;
            }
            this.friends[x].createdateShow = moment().add(-1,'days').format('DD MMM,YY')
            history.push(this.friends[x]);
          }
        }
      }else{
        this.titleDetail = 'เพื่อนแนะนำเพื่อน';
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            deposit[doc.data().code] = doc.data().total;
          });
        });
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            withdraw[doc.data().code] = doc.data().total;
          });
        });
        if(this.user.level2){
          for(const x in this.user.level2){
            if(deposit[this.user.level2[x].code]){
              this.user.level2[x].deposit = deposit[this.user.level2[x].code];
            }else{
              this.user.level2[x].deposit = 0;
            }
            if(withdraw[this.user.level2[x].code]){
              this.user.level2[x].withdraw = withdraw[this.user.level2[x].code];
            }else{
              this.user.level2[x].withdraw = 0;
            }
            this.user.level2[x].createdateShow = moment().add(-1,'days').format('DD MMM,YY')
            history.push(this.user.level2[x]);
          }
        }
      }
      this.history = history;
      this.showdetail = true;
    },
    closeDetail(){
      this.showdetail = false;
    }
  }
}
</script>

<style scoped>
/* Page Container */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #121612 0%, #0f2f12 50%, #121612 100%);
  padding-bottom: 100px;
  font-family: 'Kanit', sans-serif;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(30, 161, 66, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(144, 255, 60, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  text-shadow:
    0 0 20px rgba(144, 255, 60, 0.5),
    0 0 40px rgba(30, 161, 66, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #1ea142, #90ff3c);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #90ff3c, #1ea142);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #0f2f12, #1ea142);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Main Content */
.main-content {
  padding: 0 20px;
  margin-top: 20px;
}

/* Banner Section */
.banner-section {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(30, 161, 66, 0.2);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.banner-image {
  width: 100%;
  height: auto;
  display: block;
}

/* Referral Card */
.referral-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(30, 161, 66, 0.2);
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.referral-title {
  color: #90ff3c;
  margin-bottom: 15px;
  font-weight: 600;
  font-size: 18px;
}

.referral-input {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 15px;
}

.referral-input input {
  flex: 1;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(30, 161, 66, 0.3);
  border-radius: 8px;
  padding: 12px 15px;
  color: #fff;
  font-size: 14px;
  font-family: 'Kanit', sans-serif;
}

.referral-input input:focus {
  outline: none;
  border-color: rgba(144, 255, 60, 0.5);
  box-shadow: 0 0 10px rgba(144, 255, 60, 0.2);
}

.copy-btn {
  background: linear-gradient(135deg, #1ea142, #0f2f12);
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(30, 161, 66, 0.3);
  font-family: 'Kanit', sans-serif;
  white-space: nowrap;
}

.copy-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(144, 255, 60, 0.4);
  filter: brightness(1.1);
}

.referral-note {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin: 0;
  text-align: center;
}

/* Stats Title */
.stats-title {
  background: rgba(30, 161, 66, 0.1);
  padding: 12px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
}

/* Partner Stats Grid */
.partner-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(30, 161, 66, 0.2);
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.stat-card:hover {
  transform: translateY(-5px);
  border-color: rgba(144, 255, 60, 0.4);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.stat-card-wide {
  grid-column: 1 / -1;
}

.stat-icon {
  font-size: 48px;
  margin-bottom: 15px;
  filter: drop-shadow(0 0 10px rgba(144, 255, 60, 0.3));
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #90ff3c;
  text-shadow: 0 0 20px rgba(144, 255, 60, 0.5);
  margin-bottom: 5px;
}

.stat-unit {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.stat-action {
  margin-top: 10px;
}

.analysis-icon {
  filter: drop-shadow(0 0 8px rgba(144, 255, 60, 0.4));
  transition: transform 0.3s ease;
}

.stat-card:hover .analysis-icon {
  transform: scale(1.1);
}

/* Claim Section */
.claim-section {
  text-align: center;
  margin-bottom: 30px;
}

.claim-btn {
  background: linear-gradient(135deg, #90ff3c, #1ea142);
  border: none;
  border-radius: 8px;
  padding: 15px 40px;
  color: #000;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow:
    0 4px 15px rgba(144, 255, 60, 0.4),
    0 0 20px rgba(144, 255, 60, 0.3);
  font-family: 'Kanit', sans-serif;
}

.claim-btn:hover:not(.disabled) {
  transform: translateY(-2px);
  box-shadow:
    0 6px 25px rgba(144, 255, 60, 0.5),
    0 0 30px rgba(144, 255, 60, 0.4);
  filter: brightness(1.1);
}

.claim-btn.disabled {
  background: linear-gradient(135deg, #666, #444);
  color: #999;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

/* Details Card */
.details-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(30, 161, 66, 0.2);
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.details-text {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  font-size: 16px;
  text-align: center;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  z-index: 9999;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
}

.modal-container {
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.modal-content {
  background: linear-gradient(135deg, #121612 0%, #0f2f12 50%, #121612 100%);
  border: 2px solid rgba(30, 161, 66, 0.3);
  border-radius: 15px;
  width: 100%;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  max-height: 85vh;
  overflow-y: auto;
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(30, 161, 66, 0.3);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  color: #fff;
  font-size: 20px;
}

.modal-close:hover {
  background: rgba(144, 255, 60, 0.2);
  border-color: rgba(144, 255, 60, 0.5);
  transform: rotate(90deg);
}

.modal-header {
  padding: 30px 30px 20px;
  border-bottom: 1px solid rgba(30, 161, 66, 0.2);
}

.modal-title {
  font-size: 28px;
  font-weight: 700;
  color: #90ff3c;
  text-align: center;
  text-shadow: 0 0 15px rgba(144, 255, 60, 0.4);
  margin: 0;
}

.modal-body {
  padding: 30px;
}

.modal-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  margin-bottom: 20px;
  text-align: center;
}

/* Table Wrapper */
.table-wrapper {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(30, 161, 66, 0.2);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 20px;
}

.fixTableHead {
  overflow-y: auto;
  max-height: 400px;
}

.fixTableHead thead th {
  position: sticky;
  top: 0;
  z-index: 10;
}

.tablecontainer {
  width: 100%;
  border-collapse: collapse;
}

.tablecontainer th h1 {
  font-family: 'Kanit';
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #90ff3c;
  margin: 0;
  padding: 15px 10px;
}

.tablecontainer th {
  background: rgba(30, 161, 66, 0.2);
  border-bottom: 2px solid rgba(30, 161, 66, 0.3);
}

.tablecontainer td {
  font-family: 'Kanit';
  font-weight: normal;
  font-size: 14px;
  padding: 12px 10px;
  color: #fff;
  text-align: center;
  border-bottom: 1px solid rgba(30, 161, 66, 0.1);
}

.tablecontainer tr:nth-child(odd) {
  background-color: rgba(30, 161, 66, 0.05);
}

.tablecontainer tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.2);
}

.tablecontainer tr:hover {
  background-color: rgba(30, 161, 66, 0.1);
}

/* Contact Section */
.contact-section {
  text-align: center;
  padding: 20px;
  background: rgba(30, 161, 66, 0.05);
  border-radius: 10px;
}

.contact-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  font-family: 'Kanit', sans-serif;
}

.contact-text a {
  color: #90ff3c;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-text a:hover {
  color: #1ea142;
  text-shadow: 0 0 10px rgba(144, 255, 60, 0.5);
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .partner-stats {
    grid-template-columns: 1fr;
  }

  .stat-card-wide {
    grid-column: 1;
  }

  .referral-input {
    flex-direction: column;
  }

  .copy-btn {
    width: 100%;
  }

  .modal-content {
    margin: 20px 10px;
  }

  .modal-header {
    padding: 25px 20px 15px;
  }

  .modal-title {
    font-size: 22px;
  }

  .modal-body {
    padding: 20px 15px;
  }

  .tablecontainer th h1 {
    font-size: 12px;
    padding: 10px 5px;
  }

  .tablecontainer td {
    font-size: 12px;
    padding: 10px 5px;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-description {
    font-size: 14px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .referral-card {
    padding: 20px 15px;
  }

  .referral-input input {
    font-size: 12px;
    padding: 10px 12px;
  }

  .copy-btn {
    padding: 10px 15px;
    font-size: 14px;
  }

  .stat-card {
    padding: 20px 15px;
  }

  .stat-icon {
    font-size: 40px;
  }

  .stat-value {
    font-size: 24px;
  }

  .claim-btn {
    padding: 12px 30px;
    font-size: 16px;
  }

  .modal-close {
    width: 35px;
    height: 35px;
    font-size: 18px;
  }
}
</style>
